import React, {Fragment} from 'react';
import Modal from 'react-modal';
import { spu_createCookie } from '@tickled-media/web-components.tm-helpers';
import {Icon} from '../Common/Icon';
import {gtmSend} from '../../helpers';
import cx from '../../styles';

/*const customStyles = {
  content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      transform             : 'translate(-50%, -50%)',
      width                 : '370px'
  }
};*/

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if(typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

const BirthClubModal = ({feedReducer, isModalOpen, onModalClose, t}) => {
	return (
		<Fragment>
            <Modal 
                isOpen={isModalOpen}
                onAfterOpen={() => gtmSend('dynamic', 'Birth club - popup', 'show', '')}
                onRequestClose={onModalClose}
                overlayClassName="myOverlayClass birthclub-modal-overlay"
                // style={customStyles}
            >
                <div className={cx('birthclub-modal')}>
                    <span className={cx("close-modal")} onClick={onModalClose}>
                        <Icon name="cross-regular-dark-smd" />
                    </span>
                    <div className={cx('main-content')}>
                        <img src={feedReducer.widget.left_img} alt='birth club icon' width="180" height="180" />
                        <div className={cx('subtitle')}>{feedReducer.widget.sub_title}</div>
                        <div className={cx('title')}>{feedReducer.widget.title}</div>
                        <a 
                            href={feedReducer.widget.target_url} 
                            aria-label={t('visit_the_group')} 
                            onClick={() => {gtmSend('dynamic', 'Birth club - button', 'click', ''); spu_createCookie('birthclub_popup', feedReducer && feedReducer.widget ? feedReducer.widget.target_url : '', 24)}}
                        >
                            {t('visit_the_group')}
                        </a>
                    </div>
                </div>
            </Modal>
        </Fragment>
	)
}

export default BirthClubModal;